import { selectors } from '@store/connectedRouter'
import { connect } from 'react-redux'

export default connect(selectors.routerSelector)
